/**
 * Created by claudio iozzia on 10/04/2017.
 */
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {isEuropeRange, isEuropeRangeXFlyback} from "../../../../components/specification/v-input/preset/InputACPreset";
import {Utils} from "../../../../common/utils";

export function getMinPower(a: Ic): number {
  return Utils.getFieldValue(a, "validator.power.min", NaN);
  // return a.validator && a.validator.power && isValueReal(a.validator.power.min) ? a.validator.power.min : NaN;
}

export function getMaxEuropePower(a: Ic): number {
  return Utils.getFieldValue(a, "validator.power.maxEurope", NaN);
  // return a.validator && a.validator.power && Utils.isValueReal(a.validator.power.maxEurope) ? a.validator.power.maxEurope : NaN;
}

export function getMaxWidePower(a: Ic): number {
  return Utils.getFieldValue(a, "validator.power.maxWide", NaN);
  // return a.validator && a.validator.power && Utils.isValueReal(a.validator.power.maxWide) ? a.validator.power.maxWide : NaN;
}

export function getMaxPower(a: Ic, spec: IAppSpec): number {
  const _vin_min = spec.spec.value.input.min;
  const _vin_max = spec.spec.value.input.max;
  return isEuropeRange(_vin_min, _vin_max) ? getMaxEuropePower(a) : getMaxWidePower(a);
}

export function getMaxPowerXFlyback(a: Ic, spec: IAppSpec): number {
  const _vin_min = spec.spec.value.input.min;
  return isEuropeRangeXFlyback(_vin_min) ? getMaxEuropePower(a) : getMaxWidePower(a);
}


